import React from 'react';
import AboutHero from '../components/AboutHero';
import WhoWeAreSection from '../components/WhoWeAreSection';
import OurFacilitiesSection from '../components/OurFacilitiesSection';
import OurBenefitsSection from '../components/OurBenefitsSection';
import ScratchToImplementation from '../components/ScratchToImplementation';
import OurImpactSection from '../components/OurImpactSection';
import MissionVisionValues from '../components/MissionVisionValues';
import IndustryGrid from '../components/IndustryGrid';
import HowItWorks from '../components/HowItWorks';
import StatsGrid from '../components/StatsGrid';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import ContactUs from '../components/ContactUs';

function AboutPage({ setView }) {
  return (
    <>
      <AboutHero />
      <WhoWeAreSection setView={setView} />
      <OurFacilitiesSection />
      <OurBenefitsSection />
      <ScratchToImplementation />
      <OurImpactSection />
      <MissionVisionValues />
      <IndustryGrid />
      <HowItWorks />
      <StatsGrid />
      <WhyChooseUsSection setView={setView} />
      <ContactUs />
    </>
  );
}

export default AboutPage;
